import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface OpinionScaleFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function OpinionScaleField({ field, value, onChange }: OpinionScaleFieldProps) {
  const config = field.config;
  const min = config.min || 1;
  const max = config.max || 10;
  const showLabels = config.showLabels !== false;

  return (
    <div className="space-y-3">
      {/* Scale Buttons */}
      <div className="flex justify-between gap-1.5 md:gap-2">
        {Array.from({ length: max - min + 1 }, (_, index) => {
          const scaleValue = min + index;
          const isSelected = value === scaleValue;

          return (
            <button
              key={scaleValue}
              type="button"
              onClick={() => onChange(scaleValue)}
              className={cn(
                "flex-1 h-10 md:h-11 rounded border transition-all duration-200",
                "hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-1",
                !isSelected && "border-2"
              )}
              style={isSelected ? {
                borderColor: 'var(--ef-accent, #3B82F6)',
                background: 'var(--ef-accent, #3B82F6)',
                color: 'white',
                transform: 'scale(1.05)'
              } : {
                borderColor: 'var(--ef-border, #E2E8F0)',
                background: 'var(--ef-background, #FFFFFF)',
                color: 'var(--ef-text, #1E293B)'
              }}
            >
              <span className="text-sm font-medium">{scaleValue}</span>
            </button>
          );
        })}
      </div>

      {/* Labels */}
      {showLabels && (config.lowLabel || config.highLabel) && (
        <div className="flex justify-between text-xs font-light px-1" style={{ color: 'var(--ef-textSecondary, #64748B)' }}>
          <span>{config.lowLabel || ''}</span>
          <span>{config.highLabel || ''}</span>
        </div>
      )}
    </div>
  );
}
